/**
 * Pure component for common multi enum dropdown
 */
import { useMemo } from 'react';
import noop from 'lodash/noop';
import { MultiSelectDropdown } from '../../Dropdowns/MultiSelectDropdown';
import {
  EnumDropdownOption,
  RfiMultiselectEnumsOptionsMapping,
  getRFIEnumOptions,
} from '../../../helpers/enumOptionsHelpers';

export type PureEnumMultiDropdownProps = {
  fieldName: keyof RfiMultiselectEnumsOptionsMapping;
  value?: string[];
  onChange?: (value: EnumDropdownOption[]) => void;
  id?: string;
  disabled?: boolean;
  placeholder?: string;
  clearable?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
};

export const PureEnumMultiDropdown = ({
  fieldName,
  value,
  onChange = noop,
  id,
  disabled,
  placeholder,
  clearable,
  isOpen,
  onClose,
}: PureEnumMultiDropdownProps) => {
  const multiDropdownOptions = useMemo(() => getRFIEnumOptions(fieldName), [fieldName]);

  const selectedItems = useMemo(
    () => multiDropdownOptions.filter((el) => value && value.includes(el.value)),
    [multiDropdownOptions, value],
  );

  return (
    <MultiSelectDropdown
      id={id || fieldName}
      disabled={disabled}
      onChange={onChange}
      options={multiDropdownOptions}
      selectedItems={selectedItems}
      placeholder={placeholder}
      clearable={clearable}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};
